import React from 'react'

import { EventSubSection } from 'src/components/EventSubSection/EventSubSection'

import { HeadlinerAttractionCard } from './AttractionCards/HeadlinerAttractionCard'
import { AttractionsSubSectionProps } from './AttractionsSubSection'

const style = require('./AttractionsSection.css')

export const HeadlinerAttractionsSubSection = ({
  title,
  attractions,
  createOnSelect,
  singleSubSectionClass,
}: AttractionsSubSectionProps) => (
  <EventSubSection
    title={title}
    extendedClassName={singleSubSectionClass}
  >
    <div className={style.headlinerAttractionsSubSectionContainer}>
      {
        attractions.map(attraction => (
          <HeadlinerAttractionCard
            key={attraction.id}
            attraction={attraction}
            onClick={createOnSelect(attraction)}
          />
        ))
      }
    </div>
  </EventSubSection>
)
